<template>
    <ds-confirm-dialog
        :is-open="isConfirmModalOpen"
        title="Delete contact"
        message="Are you sure you want to delete this contact? This will also delete any data you've collected for them."
        confirm-button-class="negative"
        confirm-label="Delete"
        cancel-button-class="cancel"
        cancel-label="Cancel"
        data-qa="delete-contact"
        class="confirm-modal-custom"
        @confirm="deleteContact"
        @cancel="isConfirmModalOpen = false"
    />
</template>

<script>
import axios from 'axios';

export default {
    props: {
        contactId: [String, Number],
    },

    data() {
        return {
            isConfirmModalOpen: false,
        };
    },

    methods: {
        showModal() {
            this.isConfirmModalOpen = true;
        },

        async deleteContact() {
            const url = `/app/contact/delete/${this.contactId}`;
            const message = 'Deleted contact';

            try {
                await axios.delete(url, this.contactId);
                this.isConfirmModalOpen = false;
                this.$toast({ message });
                window.location.href = '/Reports/searchTemplate.jsp?reportClass=AdvContactSearch&view=resultsPage';
            } catch (error) {
                this.$error({ message: 'Unable to delete Contact' });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.confirm-modal-custom {
white-space: pre-line;
}
</style>
